import React, { useState } from 'react';
import Modal from 'components/Core/Modal';
import LoginModalContainer from './LoginModalContainer';
import ForgotPasswordModalContainer from './ForgotPasswordModalContainer';

const LoginModal = ({
  isModalOpen,
  handleCloseModal,
  socialAuth,
  auth,
  errorMessage,
  openSignupModal,
  handleForgotPassword,
}) => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const forgotPasswordClick = () => {
    setShowForgotPassword(true);
  };

  const openSignupModalClick = (e) => {
    setShowForgotPassword(false);
    openSignupModal(e);
  };

  return (
    <Modal
      open={isModalOpen}
      handleClose={() => {
        handleCloseModal();
        setShowForgotPassword(false);
      }}
      width="658px"
    >
      <div>
        {showForgotPassword && (
          <ForgotPasswordModalContainer
            errorMessage={errorMessage}
            openSignupModal={openSignupModalClick}
            handleSubmit={(e) => {
              setShowForgotPassword(false);
              handleForgotPassword(e);
            }}
          />
        )}
        {!showForgotPassword && (
          <LoginModalContainer
            auth={auth}
            socialAuth={socialAuth}
            authError={errorMessage}
            openSignupModal={openSignupModalClick}
            forgotPasswordClick={forgotPasswordClick}
          />
        )}
      </div>
    </Modal>
  );
};

export default LoginModal;
